import React from 'react';

const isValidUrl = (urlString) => {
    try {
        return Boolean(urlString && urlString.startsWith('http') && new URL(urlString));
    } catch (e) {
        return false;
    }
};

const CompSourceUrlList = ({ caseStudiesData, competitiveAnalysisData, industryTrendsData, businessNewsData, maxDeepData }) => {


    // console.log('--------------------------------')
    // // console.log('caseStudiesData', caseStudiesData);
    // // console.log('competitiveAnalysisData', competitiveAnalysisData);
    // // console.log('industryTrendsData', industryTrendsData);
    // // console.log('businessNewsData', businessNewsData);
    // console.log('maxDeepData', maxDeepData);
    // console.log('--------------------------------')

 
    // Extract URLs from caseStudiesData
    const caseStudyUrlsAndTitles = caseStudiesData && Array.isArray(caseStudiesData)
        ? caseStudiesData.map(study => ({ url: study.originalUrl, title: study.caseStudyTitle })).filter(item => isValidUrl(item.url))
        : [];

    // Extract URLs from competitiveAnalysisData
    const competitorUrlsAndDescriptions = competitiveAnalysisData?.battleCard?.sources && Array.isArray(competitiveAnalysisData.battleCard.sources)
        ? competitiveAnalysisData.battleCard.sources.map(source => ({ url: source.url, description: source.description })).filter(item => isValidUrl(item.url))
        : [];

    // Extract URLs from industryTrendsData
    const industryTrendUrlsAndHeadlines = industryTrendsData?.trendItems && Array.isArray(industryTrendsData.trendItems)
        ? industryTrendsData.trendItems.map(item => ({ url: item.url, headline: item.headline })).filter(item => isValidUrl(item.url))
        : [];

    // Extract URLs from businessNewsData
    const businessNewsUrlsAndHeadlines = businessNewsData?.newsItems && Array.isArray(businessNewsData.newsItems)
        ? businessNewsData.newsItems.map(item => ({ url: item.url, headline: item.headline })).filter(item => isValidUrl(item.url))
        : [];

    // Extract URLs from maxDeepData
    const maxDeepUrlsAndNames = maxDeepData?.conversation_starters && Array.isArray(maxDeepData.conversation_starters)
        ? maxDeepData.conversation_starters.map(starter => ({ url: starter.sources?.url, name: starter.sources?.name })).filter(item => isValidUrl(item.url) && item.name)
        : [];

    const renderUrlItem = (url, index, type, tooltipText) => {
        const iconSrc = `https://www.google.com/s2/favicons?domain=${isValidUrl(url) ? new URL(url).hostname : ''}&sz=64`;
        return (
            <a
                key={`${type}-${index}`}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block cursor-pointer" // Added for inline display
            >
                <span hover-tooltip={tooltipText} tooltip-position="top" className="inline-block cursor-pointer"> {/* Changed tooltip-position to top */}
                    <div className="flex items-center gap-2 bg-black/0 hover:bg-black/20 p-2 rounded-lg transition-all duration-200">
                        <div className="flex-shrink-0 p-2 rounded-lg bg-black/40 shadow-inner border border-white/5">
                            <img
                                src={iconSrc}
                                alt="" // Alt text can be improved if source name is available
                                className="w-6 h-6"
                                onError={(e) => { e.target.src = '/util/app/b3-admin-link.png'; }} // Fallback icon
                            />
                        </div>
                        {/* Optionally, display the URL or a shortened version */}
                        {/* <span className="text-zinc-400 text-xs truncate">{new URL(url).hostname}</span> */}
                    </div>
                </span>
            </a>
        );
    };

    return (
        <div className="flex flex-row flex-wrap gap-4 w-full bg-black/20 p-2 rounded-lg"> {/* Consider adding space-y-4 for consistent spacing between blocks */}

            {industryTrendUrlsAndHeadlines.length > 0 && (
                <div className="flex-1 p-4 bg-black/0 rounded-lg shadow min-w-[200px] md:min-w-[300px]">
                    <div className="mb-6">
                        <h3 className="text-sm font-normal text-zinc-100 mb-3 ml-2">Industry Trend Sources</h3>
                        <div className="flex flex-wrap gap-1">
                            {industryTrendUrlsAndHeadlines.map((item, index) => renderUrlItem(item.url, index, 'industry-trend', item.headline))}
                        </div>
                    </div>
                </div>
            )}
                
            {businessNewsUrlsAndHeadlines.length > 0 && (
                <div className="flex-1 p-4 bg-black/0 rounded-lg shadow min-w-[200px] md:min-w-[300px]">
                     <div className="mb-6">
                        <h3 className="text-sm font-normal text-zinc-100 mb-3 ml-2">Business News Sources</h3>
                        <div className="flex flex-wrap gap-1">
                            {businessNewsUrlsAndHeadlines.map((item, index) => renderUrlItem(item.url, index, 'business-news', item.headline))}
                        </div>
                    </div>
                </div>
            )}

            

            {caseStudyUrlsAndTitles.length > 0 && (
                <div className="flex-1 p-4 bg-black/0 rounded-lg shadow min-w-[200px] md:min-w-[300px]">
                    <div className="mb-6">
                        <h3 className="text-sm font-normal text-zinc-100 mb-3 ml-2">Case Study Sources</h3>
                        <div className="flex flex-wrap gap-1"> {/* Changed from ul to div for flex layout */}
                            {caseStudyUrlsAndTitles.map((item, index) => renderUrlItem(item.url, index, 'case-study', item.title))}
                        </div>
                    </div>
                </div>
            )}

            {competitorUrlsAndDescriptions.length > 0 && (
                <div className="flex-1 p-4 bg-black/0 rounded-lg shadow min-w-[200px] md:min-w-[300px]">
                    <h3 className="text-sm font-normal text-zinc-100 mb-3 ml-2">Competitor Sources</h3>
                    <div className="flex flex-wrap gap-1"> {/* Changed from ul to div for flex layout */}
                        {competitorUrlsAndDescriptions.map((item, index) => renderUrlItem(item.url, index, 'competitor', item.description))}
                    </div>
                </div>
            )}

            {maxDeepUrlsAndNames.length > 0 && (
                <div className="flex-1 p-4 bg-black/0 rounded-lg shadow min-w-[200px] md:min-w-[300px]">
                    <div className="mb-6">
                        <h3 className="text-sm font-normal text-zinc-100 mb-3 ml-2">Deep Dive Sources</h3>
                        <div className="flex flex-wrap gap-1">
                            {maxDeepUrlsAndNames.map((item, index) => renderUrlItem(item.url, index, 'max-deep', item.name))}
                        </div>
                    </div>
                </div>
            )}

            {industryTrendUrlsAndHeadlines.length === 0 && businessNewsUrlsAndHeadlines.length === 0 && caseStudyUrlsAndTitles.length === 0 && competitorUrlsAndDescriptions.length === 0 && maxDeepUrlsAndNames.length === 0 && (
                <p className="text-zinc-400">No sources to display.</p>
            )}
        </div>
    );
};

export default CompSourceUrlList; 